import { Typography } from "@mui/material";
import { StyledInputLabel } from "../../styled/Labels";

const InputLabel = ({ title }) => {

  return (
    <StyledInputLabel.Chip>
      <Typography>{title}</Typography>
    </StyledInputLabel.Chip>
  );
};

export default InputLabel;
